export const SOCIAL_MEDIA_LIST = 'SOCIAL_MEDIA_LIST';
export const CREATE_SOCIAL_MEDIA_SUCCESS = 'CREATE_SOCIAL_MEDIA_SUCCESS';
export const DELETE_SOCIAL_MEDIA_SUCCESS = 'DELETE_SOCIAL_MEDIA_SUCCESS';
export const UPDATE_SOCIAL_MEDIA_SUCCESS = 'UPDATE_SOCIAL_MEDIA_SUCCESS';
